import React, { ReactElement } from 'react';

interface Props {
  className?: string;
}

function Eye({ className }: Props): ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="black"
      viewBox="0 0 18 12"
      width="18"
      height="12"
      className={className}
    >
      <path
        stroke="none"
        fillRule="evenodd"
        d="M17.77 6c0-.359-.194-.594-.582-1.066C15.768 3.21 12.636 0 9 0 5.364 0 2.232 3.21.812 4.934.424 5.406.23 5.641.23 6c0 .359.194.594.582 1.066C2.232 8.79 5.364 12 9 12c3.636 0 6.768-3.21 8.188-4.934.388-.472.582-.707.582-1.066zM9 9a3 3 0 100-6 3 3 0 000 6z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export default Eye;
